import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { useSelector } from 'react-redux';
import Breadcrumbs from '../../../../common/BreadCrum/BreadCrum';
import PageHeadingSection from '../../../../common/pageheading/PageHeadingSection';

const GenerateQRCode = () => {
    const { user: authUser } = useSelector((state) => state.auth);
    const siteId = authUser?.siteId;


    // Create the check-in URL dynamically just like the Angular app
    const qrValue = `https://zentcomm.myhello.in/check-in?siteId=${siteId}`;

    const downloadQRCode = () => {
        const canvas = document.getElementById("visitor-qr-code");
        if (canvas) {
            const pngUrl = canvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
            const downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = "Visitor-CheckIn-QR.png";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto pt-4">
            <div className='flex flex-col gap-1'>
                <Breadcrumbs />
                <PageHeadingSection
                    mainHeading="Generate Visitor Check-In QR"
                    subHeading="Display this QR code at your reception to allow visitors to quickly self check-in."
                />
            </div>

            <div className="flex justify-center items-center mt-6">
                <div
                    onClick={downloadQRCode}
                    className="flex flex-col items-center bg-white p-4 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-gray-100 cursor-pointer hover:shadow-[0_12px_40px_rgb(0,0,0,0.12)] transition-all duration-300 transform hover:-translate-y-1"
                >
                    <div className="bg-white  rounded-xl border border-gray-100 shadow-sm mb-6">
                        <QRCodeCanvas
                            id="visitor-qr-code"
                            value={qrValue}
                            size={250}
                            level={"H"}
                            includeMargin={true}
                        />
                    </div>
                    <h3 className="text-lg font-bold text-gray-800 mb-2">Self Check-In QR</h3>
                </div>
            </div>
        </div>
    );
};

export default GenerateQRCode;
